<template>
    <div>

    </div>
</template>


<script>

require("vue-awesome-notifications/dist/styles/style.css");

import ClipboardJS from 'clipboard';

const clipboard = new ClipboardJS('.copy-mssg-button');

clipboard.on('success', function(e) {
    //console.info('Action:', e.action);
    //console.info('Text:', e.text);
    //console.info('Trigger:', e.trigger);
    e.clearSelection();
});

clipboard.on('error', function(e) {
    //console.error('Action:', e.action);
    //console.error('Trigger:', e.trigger);
});

export default {
    data() {
        return {
            // Code...
        }
    },
    created() {
        this.EventBus.$on('create-success', this.itemCreated);
        this.EventBus.$on('update-success', this.itemUpdated);
        this.EventBus.$on('delete-success', this.itemDeleted);
        this.EventBus.$on('event-info', (message) => this.itemInfo(message));
        this.EventBus.$on('event-popup-info', (message) => this.itemPUInfo(message));
        this.EventBus.$on('event-error', (message) => this.itemPUError(message));
        this.EventBus.$on('event-success', (message) => this.itemSuccess(message));
    },
    methods: {
        itemCreated() {
            this.$awn.success('Your item has been successfully saved.')
        },
        itemUpdated() {
            this.$awn.success('Your item has been successfully updated.')
        },
        itemDeleted() {
            this.$awn.success('Your item has been successfully deleted.')
        },
        itemInfo(message) {
            this.$awn.info(message)
        },
        itemPUInfo(message) {
            this.$swal({
                html: message
            })
        },
        itemError(message) {
            this.$awn.alert(message);
        },
        itemPUError(message) {
            this.$swal({
                type: 'error',
                title: 'Oops...',
                confirmButtonColor: "#DD6B55",
                html:
                    '<div id="swal-error-mgs">' +
                    message +
                    '</div><br>' +
                    '<a class="copy-mssg-button" href="#" data-clipboard-target="#swal-error-mgs">copy message</a>'
            })
        },
        itemSuccess(message) {
            this.$awn.success(message);
        }
    }
}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/EventBus.vue